<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  contactId: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(['found', 'notFound']);
const store = useStore();

const exists = ref(undefined);
const contactCache = ref(null);

const contactReactive = computed(() =>
  store.getters['contacts/getContact'](props.contactId)
);
const contact = computed(() => contactCache.value ?? contactReactive.value);
const loading = computed(() => !contactCache.value);

watch(
  contactReactive,
  value => {
    if (!value) return;
    if (!contactCache.value || value.id === props.contactId) {
      contactCache.value = value;
    }
  },
  { immediate: true }
);

watch(
  contactCache,
  value => {
    if (!value) return;
    if (value.id === props.contactId) {
      exists.value = true;
      emit('found');
    } else {
      exists.value = false;
      emit('notFound');
    }
  },
  { immediate: true }
);

function setDefaults() {
  const contactStore = store.getters['contacts/getContact'](props.contactId);
  if (contactStore && contactStore.id === props.contactId) return;
  store.dispatch('contacts/show', { id: props.contactId });
}

onMounted(() => {
  setDefaults();
});
</script>

<template>
  <slot :contact="contact" :loading="loading" :exists="exists" />
</template>
